import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateVisitAction } from '../../../redux/actions/visitActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import VisitForm from '../forms/VisitForm';

const UpdateVisitModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const visit = useSelector((state) => state.visit?.visit);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(
      updateVisitAction(visit.vin, visit.id, {
        ...data,
        startDate: dayjs(new Date(data.startDate)).toISOString(),
        endDate: dayjs(new Date(data.endDate)).toISOString(),
      }),
    );
    setLoading(false);
    onModalSubmit();
  };
  return (
    <Modal
      title={'Редагувати візит'}
      loading={loading}
      onClose={onModalClose}
      body={<VisitForm onSubmit={onSubmit} loading={loading} visit={visit} />}
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'visit-form'} children={'Зберегти'} />
      }
    />
  );
};

export default UpdateVisitModal;
